!function($, window, document) {
    const $window = $(window), $document = $(document), $body = $(document.body), $popupTriggers = $(".js-popup-trigger"), $shapes = $(".js-shape"), $header = $(".header"), $stackableItems = $(".js-stackable");
    let expandTimer, window_width = $window.outerWidth(), prevScrollPosition = 0;
    const isTouch = "ontouchstart" in window || navigator.msMaxTouchPoints > 0, setFooterHeightAsCssVariable = () => {
        const $footer = $(".footer");
        $(".wrapper").css("padding-bottom", `${$footer.outerHeight()}px`);
    }, transformShapes = () => {
        const windowTop = $window.scrollTop(), windowHeight = $window.height(), windowBottom = windowTop + windowHeight;
        $shapes.each(((_, shape) => {
            const $shape = $(shape), shapeTop = $shape.offset().top;
            if (shapeTop < windowBottom && shapeTop > windowTop) {
                const shapeModifier = 1 - (windowBottom - shapeTop) / (.9 * windowHeight);
                $shape.css("--shape-modifier", shapeModifier);
            }
        }));
    }, setStackableValues = () => {
        const windowHeight = $window.innerHeight();
        $stackableItems.each(((_, item) => {
            const $item = $(item), itemHeight = $item.outerHeight(), top = windowHeight - itemHeight;
            $item.css({
                position: "sticky",
                top: Math.min(top, 0),
                left: 0,
                willChange: "top"
            });
        }));
    };
    $.fn.isInViewportOfMap = function() {
        let elementTop = $(this).offset().top, elementBottom = elementTop + $(this).outerHeight(), viewportTop = $(".map-interactive").offset().top, viewportBottom = viewportTop + $(".map-interactive").height(), elementLeft = $(this).offset().left, elementRight = elementLeft + $(this).outerWidth(), viewportLeft = $(".map-interactive").offset().left, viewportRight = viewportLeft + $(".map-interactive").width();
        return {
            state: elementTop > viewportTop && elementBottom < viewportBottom && elementLeft > viewportLeft && elementRight < viewportRight,
            top: elementTop - viewportTop,
            left: elementLeft - viewportLeft,
            bottom: viewportBottom - elementBottom,
            right: viewportRight - elementRight
        };
    }, $window.on("widthResize", (function() {
        initStackableItems();
    }));
    const initSelects = () => {
        $("select").selectric({
            maxHeight: "auto",
            disableOnMobile: !1,
            nativeOnMobile: !1,
            optionsItemBuilder: function(itemData) {
                const newText = itemData.text.split(/(\d.*)/, 2).map((text => `<span>${text}</span>`)).join("");
                return newText;
            },
            labelBuilder: function(currItem) {
                const newText = currItem.text.split(/(\d.*)/, 2).filter((text => text && `<span>${text}</span>`)).join("");
                return newText;
            }
        });
    };
    function isDesktop() {
        return window.matchMedia("(min-width: 1024px)").matches;
    }
    function togglePlayOnHover(player) {
        (function isDesktopDevice() {
            return !window.matchMedia("(pointer: coarse)").matches;
        })() && player.togglePlay();
    }
    $popupTriggers.on("click", (function(e) {
        e.preventDefault();
        let href = this.getAttribute("href"), popup_element = document.querySelector(href);
        null != popup_element && openPopup(popup_element);
    })), $(".js-expand-overlay").on("click", (function(e) {
        e.preventDefault();
        $(this).closest(".js-expand-element").toggleClass("is-expanded").find(".js-overaly").stop().slideToggle();
    }));
    const togglePlayPauseInSlides = slides => {
        slides.each((function() {
            const $slide = $(this), $media = $slide.find(".media");
            if ($media.find(".plyr").length && ($media[0].plyr.pause(), $slide.hasClass("slick-active"))) {
                const $currentMedia = $slide.find(".media");
                !0 === $currentMedia.data("autoplay") && $currentMedia[0].plyr.play();
            }
        }));
    }, initSlider = (slider, options) => {
        const $slider = $(slider);
        $slider.each((function() {
            if (0 == $(this).find(".slick-initialized").length) {
                const $currentSlider = $(this), $sliderInitilizer = $currentSlider.find(".slider__slides");
                $sliderInitilizer.on("init", (function() {
                    togglePlayPauseInSlides($currentSlider.find(".slick-slide"));
                })), $sliderInitilizer.on("afterChange", (function() {
                    togglePlayPauseInSlides($currentSlider.find(".slick-slide"));
                })), $sliderInitilizer.on("beforeChange", (function() {
                    $slider.hasClass("js-slider-tabs") && $slider.closest(".js-tabs").find(".tooltip").addClass("is-hidden");
                })), $sliderInitilizer.slick({
                    slidesToShow: 1,
                    draggable: !1,
                    slidesToScroll: 1,
                    arrows: !0,
                    autoplay: !1,
                    dots: !1,
                    responsive: [ {
                        breakpoint: 1080,
                        settings: {
                            swipe: !0,
                            draggable: !0,
                            fade: !1
                        }
                    } ],
                    ...options
                });
            }
        }));
    }, initMobileSliders = () => {
        let is_mobile = $window.outerWidth() <= 767;
        $(".js-slider-mobile").each((function() {
            $this = $(this);
            let slider_init = $this.hasClass("slick-initialized");
            !is_mobile && slider_init ? $this.slick("unslick") : is_mobile && !slider_init && $this.slick({
                slidesToScroll: 1,
                slidesToShow: 1,
                swipe: !0,
                draggable: !0,
                infinite: !1,
                arrows: !1
            });
        }));
    }, setHeaderVisibility = (isInitial = !1) => {
        const hasHero = $(".module--hero").length > 0, isHeaderVisibleWithHero = $window.scrollTop() >= 100 && "up" === $window.data("scroll-direction"), isHeaderVisible = 0 === $window.scrollTop() || "up" === $window.data("scroll-direction");
        hasHero ? $header.toggleClass("is-visible", isHeaderVisibleWithHero) : isInitial ? $header.addClass("is-visible") : $header.toggleClass("is-visible", isHeaderVisible);
    };
    function setHeightOfElementToClosestSection() {
        $(".js-get-height").each((function(e) {
            $(this).closest("section").css("--content-height", `${$(this).outerHeight()}px`);
        }));
    }
    function openPopup(popup_element) {
        $.magnificPopup.open({
            items: {
                src: popup_element
            },
            type: "inline",
            closeBtnInside: !0,
            callbacks: {
                open: function() {
                    const $popup = $(this.content);
                    initSelects(), function initPlyrVideos(players, settings) {
                        players.each((function() {
                            const $this = $(this), $currentMedia = $this.closest(".media"), isBreakpointVideo = $this.siblings(".plyr").length > 0, isDesktopVideo = isBreakpointVideo && 0 === $this.index(), isMobileVideo = isBreakpointVideo && 1 === $this.index(), autoplay = "true" === $currentMedia.attr("data-autoplay"), allowFullscreen = "true" === $currentMedia.attr("data-allow-fullscreen"), isClickToPlay = "true" === $currentMedia.attr("data-click-to-play"), isLoop = "true" === $currentMedia.attr("data-loop"), isHover = "true" === $currentMedia.attr("data-hover"), hasMuteButton = "true" === $currentMedia.attr("data-mute-button"), isHideControls = "false" === $currentMedia.attr("data-controls"), controls = isHideControls ? [] : [ "play-large", "play", "progress", "current-time", "mute", "volume", "captions", "settings", "pip", "airplay", "fullscreen" ];
                            hasMuteButton && controls.push("mute"), allowFullscreen && controls.push("fullscreen"), 
                            isClickToPlay && controls.push("play-large");
                            const videoSettings = {
                                volume: hasMuteButton ? 100 : 0,
                                clickToPlay: isClickToPlay || !isHideControls,
                                autoplay: autoplay,
                                controls: controls,
                                muted: !0,
                                fullscreen: {
                                    enabled: controls.includes("fullscreen"),
                                    iosNative: !0
                                },
                                loop: {
                                    active: isLoop
                                },
                                vimeo: {
                                    background: !0
                                },
                                storage: {
                                    enabled: !1
                                },
                                ratio: "16:9",
                                ...settings
                            }, player = new Plyr($this[0], videoSettings);
                            $currentMedia[0].plyr = player, (autoplay || isHover) && (player.volume = 0, player.muted = !0);
                            const observer = new IntersectionObserver((entries => {
                                entries.map((entry => {
                                    entry.isIntersecting && autoplay && player && (!isBreakpointVideo || isDesktopVideo && isDesktop() || isMobileVideo && !isDesktop()) ? player.play() : player.pause();
                                }));
                            }), {
                                rootMargin: "0px +200px",
                                threshold: 0
                            });
                            player.on("ready", (() => {
                                const initialVolume = hasMuteButton ? 100 : 0;
                                player.pause(), player.volume = initialVolume, player.muted = !0, isHover && $currentMedia.on("mouseenter", (() => {
                                    togglePlayOnHover(player);
                                })).on("mouseleave", (() => {
                                    togglePlayOnHover(player);
                                })), observer.observe($currentMedia[0]), isBreakpointVideo && $(window).on("widthResize", (function(e) {
                                    observer.unobserve($currentMedia[0]), observer.observe($currentMedia[0]);
                                }));
                            })), player.on("play", (() => {
                                $currentMedia.addClass("is-played");
                            })), player.on("pause", (() => {
                                $currentMedia.removeClass("is-played");
                            })), player.on("enterfullscreen", (() => {
                                $currentMedia.addClass("is-fullscreen");
                            })), player.on("exitfullscreen", (() => {
                                $currentMedia.removeClass("is-fullscreen");
                            }));
                        }));
                    }($popup.find(".plyr")), $body.addClass("popup-open"), $body.addClass("not-scrollable"), 
                    $("#menu-popup").removeClass("is-active");
                },
                close: function() {
                    const $popup = $(this.content);
                    $popup.find(".media").length && $popup.find(".media")[0].plyr.destroy(), $body.removeClass("popup-open"), 
                    $body.removeClass("not-scrollable");
                }
            }
        });
    }
    $.event.special.widthResize = {
        setup: function() {
            const $this = $(this);
            $this.data("currentWidth", $this.width()), $this.on("resize.widthResize", (function() {
                const newWidth = $this.width();
                newWidth !== $this.data("currentWidth") && $this.data("currentWidth", newWidth).trigger("widthResize");
            }));
        },
        teardown: function() {
            $(this).off("resize.widthResize");
        }
    }, $(document).on("click", (function(e) {
        !$(e.target).closest(".menu__inner").length && $(".menu-popup").hasClass("is-active") && ($(".menu-popup").removeClass("is-active"), 
        $("body").removeClass("not-scrollable"));
    })), $(".js-toggle-menu").on("click", (function(e) {
        e.preventDefault(), setTimeout((() => {
            $("#menu-popup").toggleClass("is-active"), $("body").toggleClass("not-scrollable");
        }));
    })), $(".js-expand-container").on("mouseenter", (function(e) {
        if (isTouch) return;
        const $expandingElement = $(this);
        clearTimeout(expandTimer), $expandingElement.parent().siblings().removeClass("is-expanded").find(".js-overaly").stop().slideUp(), 
        expandTimer = setTimeout((function() {
            $expandingElement.parent().addClass("is-expanded"), $expandingElement.find(".js-overaly").stop().slideDown();
        }), 100);
    })), $(".js-expand-container").on("mouseleave", (function(e) {
        if (isTouch) return;
        const $expandingElement = $(this);
        clearTimeout(expandTimer), $expandingElement.find(".js-overaly").stop().slideUp(), 
        expandTimer = setTimeout((function() {
            $(".js-expand-element").removeClass("is-expanded");
        }), 100);
    })), $("a:not(.js-popup-trigger)").on("click", (function(e) {
        let href = new URL(this.href);
        if ("" == href.hash) return;
        let $target = $(href.hash);
        0 != $target.length && (e.preventDefault(), window.scrollTo({
            top: $target.offset().top,
            behavior: "smooth"
        }));
    })), $document.on("gform_post_render", (() => {
        initSelects();
    })), initMobileSliders(), setStackableValues(), setHeightOfElementToClosestSection(), 
    function showUrlHashContent() {
        let hash = window.location.hash;
        if ("" == hash) return;
        let element = document.querySelector(hash);
        null != element && element.classList.contains("mfp-hide") && openPopup(element);
    }(), initSlider(".js-slider-articles", {
        arrows: !1,
        dots: !0,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: !0,
        autoplaySpeed: 3e3,
        fade: !0,
        pauseOnHover: !1
    }), initSlider(".js-slider-articles-no-dots", {
        arrows: !1,
        dots: !1,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: !0,
        autoplaySpeed: 3e3,
        pauseOnHover: !1,
        fade: !0
    }), initSlider(".js-slider-news", {
        arrows: !1,
        dots: !1,
        slidesToShow: 3,
        autoplay: !0,
        slidesToScroll: 3,
        responsive: [ {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        } ]
    }), $window.on("load", (() => {
        setHeaderVisibility(!0), transformShapes(), setFooterHeightAsCssVariable();
    })).on("resize", (() => {
        let new_window_width = $window.outerWidth();
        transformShapes(), setStackableValues(), setHeightOfElementToClosestSection(), setFooterHeightAsCssVariable(), 
        (window_width > 767 && new_window_width <= 767 || window_width <= 767 && new_window_width > 767) && initMobileSliders(), 
        window_width = new_window_width;
    })).on("scroll", (() => {
        setFooterHeightAsCssVariable(), (() => {
            const currentScrollPosition = $window.scrollTop(), scrollDirection = currentScrollPosition > prevScrollPosition;
            prevScrollPosition = currentScrollPosition, $window.data("scroll-direction", scrollDirection ? "down" : "up");
        })(), setHeaderVisibility(), transformShapes();
    }));
}(jQuery, window, document);